import {
  BrandAndMarketListItem,
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
  Int32IdAndLabel,
  ProviderCredentialV2OrderValue,
} from '../../../integrated-client/models';
import { DEFAULT_PAGE_SIZE, DEFAULT_TOTAL_ITEMS } from '../../../utils/Constants';

export interface IFiltersData {
  brandAndMarket?: BrandAndMarketListItem | null;
  supplier?: GuidIdAndLabel | null;
  distributionChannel?: Int32IdAndLabel | null;
  agency?: GuidIdCodeAndLabel | null; 
  showDisabled?: boolean;
  orderValue?: ProviderCredentialV2OrderValue;
  orderByDescending?: boolean;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem | null;
  supplier?: GuidIdAndLabel | null;
  distributionChannel?: Int32IdAndLabel | null;
  agency?: GuidIdCodeAndLabel | null;
  showDisabled?: boolean;
  orderValue?: ProviderCredentialV2OrderValue;
  orderByDescending?: boolean;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;

  constructor() {
    this.brandAndMarket = null;
    this.supplier = null;
    this.distributionChannel = null;
    this.agency = null;
    this.showDisabled = false;
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }
}
